import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: '1',
    width: 'calc(100% - 4rem)',
    marginLeft: 'auto',
    marginRight: 'auto',
    borderRadius: '0',
    boxSizing: 'border-box',
    background: 'url("/imgs/chat-bg.png")',
    backgroundColor: '#f2f2f2',

    '& > :not(:last-child)': {
      marginBottom: '10px'
    },

    borderBottomLeftRadius: '16px',
    borderBottomRightRadius: '16px',
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      width: '100%'
    }
  },

  start: {
    marginTop: '20px',
    borderTopLeftRadius: '16px',
    borderTopRightRadius: '16px'
  },

  end: {
    borderBottomLeftRadius: '16px',
    borderBottomRightRadius: '16px'
  },

  forceAddMarginBottom: {
    '& >:last-child': {
      paddingBottom: '10px'
    }
  }
}))

export default useStyles
